'use strict'

// const uri = (process.env.VUE_APP_STATUS == 'prod') ? 'http://194.67.78.114:81' : 'http://localhost:3000'
const uri = 'http://portal.zmi59.ru:81'

//test
//test
// const uri = 'http://localhost:4000';

export default uri
